<template>
  <v-dialog v-model="dialog" max-width="600px">
    <BaseBodyDialog :title="formTitle" @close="close" @save="save">
      <v-form class="mt-6" ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="editedItem.name"
              label="Tên phòng học"
              outlined
              dense
              :rules="[$rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model.number="editedItem.capacity"
              label="Sức chứa"
              type="number"
              outlined
              dense
              :rules="[$rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="editedItem.building"
              label="Tòa nhà"
              outlined
              dense
              :rules="[$rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="editedItem.floor"
              label="Tầng"
              outlined
              dense
              :rules="[$rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="editedItem.department"
              :items="departments"
              item-text="title"
              item-value="id"
              label="Cơ sở"
              outlined
              dense
              :rules="[$rules.required]"
            ></v-select>
          </v-col>
        </v-row>
      </v-form>
    </BaseBodyDialog>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'

export default {
  name: 'ClassroomDialog',
  components: {
    BaseBodyDialog,
  },
  props: {
    dialog: Boolean,
    formTitle: String,
    editedItem: Object,
  },
  data() {
    return {
      valid: true,
    }
  },
  computed: {
    ...mapState('department', ['departments']),
  },
  methods: {
    ...mapActions('department', ['fetchDepartments']),
    close() {
      this.$emit('close')
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$emit('save')
      }
    },
  },
  created() {
    this.fetchDepartments()
  },
}
</script>

<style scoped>
.v-card__title {
  font-size: 1.5rem;
}
</style>
